import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GermplasmService } from '../../../shared/germplasm/service/germplasm.service';
import { HttpResponse } from '@angular/common/http';
import { JhiLanguageService } from '../../../shared/core-utils';
import { ParamContext } from '../../../shared/service/param.context';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmDto } from '../../../shared/germplasm/model/germplasm.model';

@Component({
    selector: 'jhi-inventory-details',
    templateUrl: './inventory-details.component.html'
})
export class InventoryDetailsComponent implements OnInit {

    gid: number;
    title: String;
    isModal: boolean;

    constructor(private activeModal: NgbActiveModal,
                private route: ActivatedRoute,
                private germplasmService: GermplasmService,
                private paramContext: ParamContext,
                private translateService: TranslateService,
                private languangeService: JhiLanguageService
    ) {
        this.paramContext.readParams();

        this.route.queryParams.subscribe((value) => {
            this.gid = value.gid;
        });

        this.isModal = this.route.snapshot.queryParamMap.has('modal');
    }

    ngOnInit() {
        const currentLang = this.languangeService.getCurrentLanguage();
        this.languangeService.changeLanguage(currentLang);

        (<any>window).onCloseModal = this.cancel;

        this.germplasmService.getGermplasmById(this.gid).subscribe(
            (res: HttpResponse<GermplasmDto>) => this.onSuccess(res.body)
        );
    }

    private onSuccess(data: GermplasmDto) {
        this.title = this.translateService.instant('inventory-details.title',
            { param1: data.preferredName, param2: this.gid });
    }

    cancel() {
        this.activeModal.dismiss();
        if ((<any>window.parent).closeModal) {
            (<any>window.parent).closeModal();
        }
    }

}
